import { render, staticRenderFns } from "./account-settings-account.vue?vue&type=template&id=10f6208e"
import script from "./account-settings-account.vue?vue&type=script&lang=js"
export * from "./account-settings-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports